(function () {
  "use strict";

  angular.module("sempraWebapp").directive("layoutAsideMenu", asideMenuInject);

  /** @ngInject */
  function asideMenuInject() {
    var directive = {
      restrict: "EA",
      templateUrl: "app/components/asideMenu/asideMenu.html",
      controller: AsideMenuController,
      controllerAs: "vm",
      scope: {
        localValue: "=?menu"
      },
      replace: true,
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function AsideMenuController(
      $mdSidenav,
      $scope,
      AsideMenuViewModel,
      $state,
      brand,
      version,
      sessionData
    ) {
      var vm = this;

      vm.asideMenu = new AsideMenuViewModel();
      vm.brand = brand;
      vm.version = version;
      vm.smallMenu = vm.localValue;

      vm.closeMenu = function () {
        $mdSidenav("left").close();
      };

      vm.setSmallMenu = function () {
        vm.smallMenu = !vm.smallMenu;
        sessionData.setValue(sessionData.Keys.SMALL_MENU, vm.smallMenu);
      };

      vm.getBrandIcon = function () {
        switch (true) {
          case vm.brand === "karcher":
            return "assets/images/logo_Karcher_white.svg";
          case vm.brand === "r2w" && !vm.smallMenu:
            return "assets/images/logoComplete.svg";
          case vm.brand === "r2w" && vm.smallMenu:
            return "assets/images/logor2w.svg";
        }
      };

      init();

      function init() {
        $scope.$on("$destroy", destroy);
      }

      function destroy() {
        vm.asideMenu.destroy();
      }
    }
  }
})();
